import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "storeClass"];
import * as React from 'react';
import { useEventCalendar } from "../use-event-calendar/index.mjs";
import { SchedulerStoreContext } from "../use-scheduler-store-context/useSchedulerStoreContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export function EventCalendarProvider(props) {
  const {
      children,
      storeClass
    } = props,
    parameters = _objectWithoutPropertiesLoose(props, _excluded);
  const store = useEventCalendar(parameters, storeClass);
  return /*#__PURE__*/_jsx(SchedulerStoreContext.Provider, {
    value: store,
    children: children
  });
}